import { useBlocker, useBeforeUnload } from "react-router-dom";
import { useFormContext } from "@/contexts/FormContext";
import { ExitWarningModal } from "@/components/ExitWarningModal";

export function NavigationBlocker() {
  const { isDirty } = useFormContext();

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname,
  );

  useBeforeUnload(
    (event) => {
      if (isDirty) {
        event.preventDefault();
      }
    },
    { capture: true },
  );

  const handleContinueEditing = () => {
    blocker.reset?.();
  };

  const handleLeave = () => {
    blocker.proceed?.();
  };

  return (
    <ExitWarningModal
      isOpen={blocker.state === "blocked"}
      onContinueEditing={handleContinueEditing}
      onDeleteAndLeave={handleLeave}
    />
  );
}
